import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const LOGO_URL = "/logo.png";

export default function Landing() {
  const nav = useNavigate();
  // Gate the animation start on the image being fully decoded so users never see a
  // half-loaded / partially-painted logo pop before the reveal animation.
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      nav("/home");
    }, 5000);
    // Safety net: if the logo image never loads (network / CDN outage), reveal
    // the placeholder after 1.2s so we never show a permanently blank splash.
    const fallback = setTimeout(() => setLoaded(true), 1200);
    return () => {
      clearTimeout(timer);
      clearTimeout(fallback);
    };
  }, [nav]);

  return (
    <div
      className="min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="landing-page"
      style={{ background: "#FFF7ED" }}
    >
      <img
        src={LOGO_URL}
        alt="Rate-ED"
        loading="eager"
        decoding="sync"
        onLoad={() => setLoaded(true)}
        className={
          "h-56 sm:h-72 md:h-96 w-auto object-contain " +
          (loaded ? "landing-logo-expand" : "opacity-0")
        }
        data-testid="landing-logo"
      />
      <style>{`
        @keyframes landingLogoExpand {
          0%   { transform: scale(0.55); opacity: 0; }
          35%  { transform: scale(1);    opacity: 1; }
          85%  { transform: scale(1);    opacity: 1; }
          100% { transform: scale(1.12); opacity: 0; }
        }
        .landing-logo-expand {
          animation: landingLogoExpand 4.6s cubic-bezier(0.22, 0.61, 0.36, 1) forwards;
          transform-origin: center center;
          will-change: transform, opacity;
        }
      `}</style>
    </div>
  );
}
